import { Component, computed, inject, input, NgZone, OnDestroy } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { vigilarColorTextoGrafico } from '../../helpers/color-grafico';
import { PieChartData } from '../../helpers/grafico-pie';

@Component({
  selector: 'app-grafico-torta',
  standalone: true,
  imports: [ChartModule],
  templateUrl: './grafico-torta.component.html',
  styleUrl: './grafico-torta.component.scss',
})
export class GraficoTortaComponent implements OnDestroy {
  private readonly texto = vigilarColorTextoGrafico(inject(NgZone));

  readonly data = input.required<PieChartData>();

  readonly piePlugins = [ChartDataLabels];
  readonly pieOptions = computed(() => {
    const color = this.texto.color();
    return {
      color,
      plugins: {
        legend: { position: 'top' as const, labels: { color } },
        datalabels: {
          color: '#fff',
          font: { weight: 'bold' as const },
          formatter: (value: number, context: { chart: { data: { datasets: { data: number[] }[] } } }) => {
            const slices = context.chart.data.datasets[0]?.data ?? [];
            const total = slices.reduce((sum, item) => sum + item, 0);
            if (!total) {
              return '0%';
            }
            return `${Math.round((value / total) * 100)}%`;
          },
        },
        tooltip: {
          callbacks: {
            label: (context: { label?: string; parsed: number }) => `${context.label}: ${context.parsed}`,
          },
        },
      },
      responsive: true,
      maintainAspectRatio: false,
    };
  });

  ngOnDestroy(): void {
    this.texto.destruir();
  }
}
